import { StyleSheet } from 'react-native';
export const hubColors = { ink: '#202737', teal: '#37958B', mint: '#B4EDE3', success: '#457714', error: '#CB1119' };
export const styles = StyleSheet.create({
  flex: { flex: 1 },
  screen: { flex: 1, backgroundColor: '#FFFFFF' },
  container: { flex: 1, width: '100%', maxWidth: 480, alignSelf: 'center' },
  header: { height: 56, flexDirection: 'row', alignItems: 'center', paddingHorizontal: 16, gap: 4 },
  headerCenter: { flex: 1, alignItems: 'center', justifyContent: 'center' },
  iconButton: { width: 40, height: 40, alignItems: 'center', justifyContent: 'center' },
  tabs: { flexDirection: 'row', borderRadius: 1000, padding: 4 },
  tab: { height: 40, paddingHorizontal: 12, borderRadius: 1000, flexDirection: 'row', alignItems: 'center' },
  tabLabel: { paddingHorizontal: 8 },
  tabLabelClip: { overflow: 'hidden' },
  measureLabel: { opacity: 0, position: 'absolute', pointerEvents: 'none', width: 240, alignItems: 'flex-start' },
  body: { fontSize: 16, lineHeight: 19.2 },
  title: { fontSize: 24, lineHeight: 28.8 },
  content: { flex: 1, paddingHorizontal: 16, paddingTop: 16 },
  card: {
    borderRadius: 16,
    borderWidth: 1,
    shadowColor: '#282725',
    shadowOffset: { width: 0, height: 2 },
    shadowRadius: 3.5,
    shadowOpacity: 0.16,
    elevation: 3,
  },
  stack: { position: 'absolute', top: -8, bottom: 8, left: 16, right: 16 },
  clipped: { borderRadius: 16, overflow: 'hidden' },
  center: { flex: 1, alignItems: 'center', justifyContent: 'center', padding: 32, gap: 40 },
  copy: { alignItems: 'center', gap: 16, width: '100%' },
  compactCopy: { alignItems: 'center', gap: 16, width: '100%' },
  completionCopy: { alignItems: 'center', gap: 8, width: '100%' },
  completionLabel: { fontSize: 18, lineHeight: 21.6 },
  dock: { padding: 16, gap: 12 },
  button: {
    minHeight: 56,
    borderRadius: 1000,
    paddingHorizontal: 16,
    paddingVertical: 12,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    gap: 8,
  },
  smallButton: { minHeight: 40, paddingHorizontal: 12, paddingVertical: 8 },
  smallButtonText: { fontSize: 14, lineHeight: 16.8 },
  buttonRow: { flexDirection: 'row', gap: 8 },
  progress: { alignItems: 'center', gap: 12 },
  track: { width: 160, height: 4, borderRadius: 2, overflow: 'hidden' },
  itemName: { position: 'absolute', left: 24, right: 24, bottom: 24 },
  quickOverview: { width: '100%' },
  quickOfferCardShadow: {
    height: 240,
    borderRadius: 16,
    shadowColor: '#282725',
    shadowOffset: { width: 0, height: 2 },
    shadowRadius: 7,
    shadowOpacity: 0.16,
    elevation: 3,
  },
  quickOfferCard: {
    flex: 1,
    alignItems: 'center',
    gap: 10,
    paddingTop: 32,
    borderRadius: 16,
    overflow: 'hidden',
  },
  quickSignal: {
    minHeight: 24,
    justifyContent: 'center',
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 8,
    backgroundColor: '#D9F2EB',
  },
  quickSignalText: { fontSize: 12, lineHeight: 14.4, color: '#005A5D' },
  quickOfferTitle: { fontSize: 18, lineHeight: 21.6, color: '#000000' },
  quickProgress: { minHeight: 16, flexDirection: 'row', alignItems: 'center', gap: 8 },
  quickProgressText: { fontSize: 12, lineHeight: 14.4, color: hubColors.ink },
  quickProgressTrack: { width: 88, height: 4, borderRadius: 2, overflow: 'hidden' },
  quickProgressFill: { height: 4, borderRadius: 2, backgroundColor: hubColors.teal },
  quickCardButton: {
    minHeight: 32,
    justifyContent: 'center',
    paddingHorizontal: 12,
    paddingVertical: 4,
    borderRadius: 1000,
    backgroundColor: hubColors.ink,
  },
  quickBenefits: { alignItems: 'stretch', gap: 24, paddingHorizontal: 16, paddingVertical: 24 },
  quickBenefitList: { gap: 16, paddingHorizontal: 16 },
  quickBenefitRow: { width: '100%', flexDirection: 'row', alignItems: 'flex-start', gap: 16 },
  quickBenefitCopy: { flex: 1, gap: 4 },
  quickBenefitText: { fontSize: 16, lineHeight: 22.4, color: '#000000' },
  thumbnails: { flexDirection: 'row', gap: 8, justifyContent: 'center', flexWrap: 'wrap' },
  thumbnail: { width: 64, height: 64, borderRadius: 8 },
  stat: { alignItems: 'center', gap: 8 },
  stats: { alignItems: 'center', gap: 24, width: '100%' },
  notice: { paddingHorizontal: 16, paddingVertical: 8, gap: 8 },
  sheet: { paddingHorizontal: 20, paddingBottom: 20, gap: 16 },
});
